import { getUserBearerCookie } from '@/features/user/cookies/cookie-user-bearer';
import { type UserReport } from '@/features/user/types/user-report-types';
import sendHttpError from '@/libs/logger/requests/send-http-error';

export default async function sendUserReport(report: UserReport): Promise<boolean> {
  const bearerToken = getUserBearerCookie();
  const headers: HeadersInit = { 'Content-Type': 'application/json' };

  if (bearerToken) {
    headers.Authorization = `Bearer ${bearerToken}`;
  }

  const body = {
    user_report: {
      complaint_type: report.reportType,
      description: report.reportText,
      user_id: report.userId,
    },
  };
  const url = `${process.env.NEXT_PUBLIC_API_URL}/v1/users`;

  const userResponse = await fetch(
    url,
    {
      body: JSON.stringify({
        user_report: {
          complaint_type: report.reportType,
          description: report.reportText,
          user_id: report.userId,
        },
      }),
      cache: 'no-store',
      headers,
      method: 'PUT',
    },
  );

  if (!userResponse.ok) {
    sendHttpError({
      baseName: 'Send report on user',
      body,
      functionName: 'sendUserReport',
      method: 'PUT',
      statusCode: userResponse.status,
      url,
    });
  }

  return userResponse.status === 200;
}
